import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { aggregateID } from "lib/id";

import {
  getShopItemByID,
  getShopItemBasketQuantity,
  getShopItemMaxBasketQuantity,
  isShopItemSeen,
  getGoToShopItemID
} from "state/school_money/selectors";
import { setShopItemBasketQuantity } from "state/school_money/actions";

import Card from "components/Card";
import Currency from "components/Currency";
import Highlight from "components/Highlight";
import AddButton from "components/school_money/AddButton";
import NewIndicator from "components/school_money/NewIndicator";
import StockLimitReachedAlert from "components/school_money/shop/StockLimitReachedAlert";

import "./ShopItem.css";

class ShopItem extends React.Component {

  state = {
    showStockLimitReachedAlert : false
  }

  onStockLimitReachedAlertClose = () => {
      this.setState({showStockLimitReachedAlert : false});
  }

  incrementBasketQuantity = () => {
    if (this.isAtMaxBasketQuantity()) {
      this.setState({showStockLimitReachedAlert : true});
    }else{
      this.props.setBasketQuantity(this.props.quantityInBasket + 1);
    }
  }

  isAtMaxBasketQuantity() {
    const { quantityInBasket, maxBasketQuantity } = this.props;
    return quantityInBasket >= maxBasketQuantity;
  }

  render() {
    
    const { shopItem, quantityInBasket, isSeen, isHighlighted, innerRef } = this.props;
    const { name, price } = shopItem;

    const isInBasket = quantityInBasket > 0;
    const classNames = [ "shop-item" ];

    if (isInBasket) {
      classNames.push("shop-item--in-basket");
    }
    if (this.isAtMaxBasketQuantity()) {
      classNames.push("shop-item--at-max-quantity");
    }

    return (
      <div className={classNames.join(" ")} ref={innerRef}>
        <Highlight cssModifier="school_money" isHighlighted={isHighlighted}>
          <Card>
            <Card.Body>
              { isSeen ? null : <NewIndicator className="shop-item__new-indicator" /> }
              <div className="shop-item__body">
                <div className="shop-item__name">{ name }</div>
                <div className="shop-item__price">
                  <Currency amount={price} />
                  { isInBasket ? <div className="shop-item__basket-quantity">{quantityInBasket}</div> : null }
                </div>
                <div className="shop-item__button">
                  <AddButton className="shop-item__add-button" onClick={this.incrementBasketQuantity} />
                </div>
                {this.state.showStockLimitReachedAlert ? <StockLimitReachedAlert itemName={ name } onClose={this.onStockLimitReachedAlertClose}/> : null}
              </div>
            </Card.Body>
          </Card>
        </Highlight>
      </div>
    );

  }

}

export default connect(
  (state, { studentID, shopItemID }) => ({
    shopItem: getShopItemByID(state, shopItemID),
    quantityInBasket: getShopItemBasketQuantity(state, shopItemID, studentID),
    isSeen: isShopItemSeen(state, shopItemID),
    isHighlighted: aggregateID(studentID, shopItemID) === getGoToShopItemID(state),
    maxBasketQuantity: getShopItemMaxBasketQuantity(state, shopItemID)
  }),
  (dispatch, { shopItemID, studentID }) => bindActionCreators({
    setBasketQuantity: quantity => setShopItemBasketQuantity(shopItemID, studentID, quantity)
  }, dispatch),
)(ShopItem);



// WEBPACK FOOTER //
// ./src/components/school_money/shop/ShopItem.js